import {
  LIQUID_GLASS_DEFAULTS,
  LIQUID_GLASS_PERFORMANCE_DEFAULTS,
  LiquidGlassElement,
  configureLiquidGlassPerformance,
  defineLiquidGlass,
  getLiquidGlassPerformanceState,
  normalizeLiquidGlassOptions
} from './core.js'
import {
  LIQUID_GLASS_NAVBAR_DEFAULTS,
  LiquidGlassNavbarElement,
  defineLiquidGlassNavbar,
  normalizeLiquidGlassNavbarOptions
} from './navbar.js'

defineLiquidGlass()
defineLiquidGlassNavbar()

export {
  LIQUID_GLASS_DEFAULTS,
  LIQUID_GLASS_PERFORMANCE_DEFAULTS,
  LiquidGlassElement,
  configureLiquidGlassPerformance,
  defineLiquidGlass,
  getLiquidGlassPerformanceState,
  normalizeLiquidGlassOptions,
  LIQUID_GLASS_NAVBAR_DEFAULTS,
  LiquidGlassNavbarElement,
  defineLiquidGlassNavbar,
  normalizeLiquidGlassNavbarOptions
}
